import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import CreatePolicy from "../CreatePolicy";
import AutoPolicySummary from "../AutoPolicySummary";
import PropertyPolicySummary from "../PropertyPolicySummary";
import UmbrellaPolicySummary from "../UmbrellaPolicySummary";
import CreateVehicle from "../CreateVehicle";
import CreateDriver from "../CreateDriver";
import Modal from "react-modal";
import ClientUpdateForm from "../ClientUpdateForm";

const customStylesModal = {
  content: {
    padding: "5px 5px",
    border: "thick solid black",
    overflowX: "auto"
  }
};

function EditClient({ agents }) {
  const [formData, setFormData] = useState({
    clientSelected: "",
    clients: "",
    editClientMetadata: false,
    agents: null,
    showCreateVehicle: false,
    showCreateDriver: false,
    showAutoPolicies: false,
    showPropertyPolicies: false,
    showUmbrellaPolicies: false,
    clientData: null,
    openEditModal: false
  });

  useEffect(() => {
    API.getClients()
      .then((res) => {
        setFormData((prev) => ({ ...prev, clients: res.data }));
      })
      .catch((err) => console.log(err));

    API.getAgents()
      .then((res) => {
        setFormData((prev) => ({ ...prev, agents: res.data }));
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const populateClientData = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (!formData.clientSelected) {
      alert("Need to select a client!");
      return;
    }

    API.findClient(formData.clientSelected).then((res) => {
      setFormData((prev) => ({
        ...prev,
        clientData: res.data
      }));
    });
  };

  const showCreateVehicle = () => {
    setFormData((prev) => ({
      ...prev,
      showCreateVehicle: !prev.showCreateVehicle
    }));
  };

  const showCreateDriver = () => {
    setFormData((prev) => ({
      ...prev,
      showCreateDriver: !prev.showCreateDriver
    }));
  };

  const showAutoPolicies = () => {
    setFormData((prev) => ({
      ...prev,
      showAutoPolicies: !prev.showAutoPolicies
    }));
  };

  const showPropertyPolicies = () => {
    setFormData((prev) => ({
      ...prev,
      showPropertyPolicies: !prev.showPropertyPolicies
    }));
  };

  const showUmbrellaPolicies = () => {
    setFormData((prev) => ({
      ...prev,
      showUmbrellaPolicies: !prev.showUmbrellaPolicies
    }));
  };

  const saveClientMetadata = (e) => {
    e.preventDefault();
    if (formData.editClientMetadata) {
      setFormData((prev) => ({
        ...prev,
        editClientMetadata: false
      }));
    }
  };

  const openEditModal = (_data) => {
    setFormData((prev) => ({
      ...prev,
      openEditModal: !prev.openEditModal
    }));
  };

  const closeEditModal = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      openEditModal: !prev.openEditModal
    }));
  };

  const getAgentNameFromID = (id) => {
    if (!agents) {
      return "";
    }
    for (let i = 0; i < agents.length; i++) {
      if (id === agents[i]._id) {
        return agents[i].firstName + " " + agents[i].lastName;
      }
    }
    return "";
  };

  return (
    <div>
      <div className="card-body" style={{ textAlign: "center" }}>
        <Modal
          isOpen={formData.openEditModal}
          onRequestClose={(e) => closeEditModal(e)}
          style={customStylesModal}
        >
          <button
            style={{
              width: "10%",
              marginLeft: "80%",
              textAlign: "center",
              backgroundColor: "white",
              color: "black"
            }}
            onClick={(e) => closeEditModal(e)}
          >
            X
          </button>
          <ClientUpdateForm clientData={formData.clientData} agents={agents} />
        </Modal>

        <h3>Edit Client</h3>
        <p>Select the Client to Edit below</p>

        <form>
          {formData.clients ? (
            <div>
              <input
                list="clients"
                style={{ width: "50%" }}
                value={formData.clientSelected}
                name="clientSelected"
                onChange={handleInputChange}
              />
              <datalist id="clients">
                {formData.clients.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.firstName} {client.lastName}
                  </option>
                ))}
              </datalist>
              <button
                style={{
                  color: "black",
                  fontSize: "20px",
                  background: "transparent",
                  backgroundImage: "linear-gradient(147deg, white 90%, black 0%)",
                  width: "250px",
                  border: "thick solid black"
                }}
                className="btn btn-sm btn-info"
                onClick={populateClientData}
              >
                Search
              </button>
            </div>
          ) : null}
        </form>

        {formData.clientData ? (
          <>
            <div className="card">
              <div className="card-header">
                <h4>Client Information</h4>
              </div>
              <div className="card-body">
                {formData.editClientMetadata ? (
                  <form>
                    <input type="text" />
                    <br />
                    <button
                      onClick={(e) => {
                        saveClientMetadata(e);
                      }}
                    >
                      Save
                    </button>
                  </form>
                ) : (
                  <div>
                    <p>
                      Client Phone:{" "}
                      {formData.clientData.telephone && formData.clientData.telephone.length === 10
                        ? formData.clientData.telephone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
                        : formData.clientData.telephone}
                    </p>
                    <p>Client Email: {formData.clientData.email}</p>
                    <p>Client Agent #1: {getAgentNameFromID(formData.clientData.agent1)}</p>
                    <p>Client Agent #2: {getAgentNameFromID(formData.clientData.agent2)}</p>
                    <p>Client Agent #3: {getAgentNameFromID(formData.clientData.agent3)}</p>
                    <button onClick={(_e) => openEditModal(formData.clientData)}>Edit</button>
                  </div>
                )}
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <h3>{formData.clientData.firstName + " " + formData.clientData.lastName}:</h3>
              </div>
              <div className="card-body">
                <CreatePolicy
                  clientID={formData.clientData._id}
                  clientFirstName={formData.clientData.firstName}
                  clientLastName={formData.clientData.lastName}
                  agents={formData.agents}
                  rerender={populateClientData}
                />
              </div>
            </div>

            <br />
            <div className="card">
              <div className="card-header">
                <h4>Auto Policies</h4>
                <button className="btn btn-success" onClick={showAutoPolicies}>
                  Show / Hide
                </button>
              </div>
              <div className="card-body">
                {formData.showAutoPolicies ? (
                  <div className="row">
                    {formData.clientData.autos ? (
                      <>
                        <div className="col-lg-12">
                          {formData.clientData.autos.map((autoData) => (
                            <AutoPolicySummary
                              key={autoData._id}
                              autoData={autoData}
                              admin={true}
                              colSize="col-lg-12"
                              agents={formData.agents}
                            />
                          ))}
                        </div>

                        <div className="col-lg-12">
                          <div className="card bg-light" style={{ color: "whitesmoke", width: "" }}>
                            <div className="card-header">
                              <button className="btn btn-dark" onClick={showCreateVehicle}>
                                Create Vehicle
                              </button>
                            </div>
                            <div className="card-body">
                              {formData.showCreateVehicle ? (
                                <CreateVehicle
                                  autoData={formData.clientData.autos}
                                  clientID={formData.clientData._id}
                                />
                              ) : null}
                            </div>
                          </div>

                          <br />

                          <div className="card bg-light" style={{ color: "whitesmoke", width: "" }}>
                            <div className="card-header">
                              <button className="btn btn-dark" onClick={showCreateDriver}>
                                Create Driver
                              </button>
                            </div>
                            <div className="card-body">
                              {formData.showCreateDriver ? (
                                <CreateDriver
                                  autoData={formData.clientData.autos}
                                  clientID={formData.clientData._id}
                                />
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <p>No Autos for this Client yet</p>
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <h4>Property Policies</h4>
                <button className="btn btn-success" onClick={showPropertyPolicies}>
                  Show / Hide
                </button>
              </div>
              {formData.showPropertyPolicies ? (
                <div className="card-body">
                  {formData.clientData.properties ? (
                    <>
                      {formData.clientData.properties.map((propertyData) => (
                        <PropertyPolicySummary
                          key={propertyData._id}
                          propertyData={propertyData}
                          colSize={"col-lg-12"}
                          admin={true}
                          agents={formData.agents}
                        />
                      ))}
                    </>
                  ) : (
                    <p>No Properties for this Client yet</p>
                  )}
                </div>
              ) : null}
            </div>
            <br />

            <div className="card">
              <div className="card-header">
                <h4>Umbrella Policies</h4>
                <button className="btn btn-success" onClick={showUmbrellaPolicies}>
                  Show / Hide
                </button>
              </div>
              <div className="card-body">
                {formData.showUmbrellaPolicies ? (
                  <>
                    <div className="col-lg-12"></div>
                    {formData.clientData.umbrellas ? (
                      <>
                        {formData.clientData.umbrellas.map((umbrellaData) => (
                          <div
                            className="col-lg-12"
                            style={{ textAlign: "center" }}
                            key={umbrellaData._id}
                          >
                            <UmbrellaPolicySummary
                              umbrellaData={umbrellaData}
                              admin={true}
                              colSize={"col-lg-12"}
                              agents={formData.agents}
                            />
                          </div>
                        ))}
                      </>
                    ) : (
                      <p>No Umbrellas for this client yet</p>
                    )}
                    <div className="col-lg-3"></div>
                  </>
                ) : null}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default EditClient;
